import useDashboardStore from "MyDashboards/state/useDashboardStore";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useCurrentUser from "qpr-base/context/UserContext";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";
import MyDashboard from "../../components/Dashboard/Dashboard";
import useMyDashboardStyles from "./themes";
const MyDashboards = () => {
  const classes = useMyDashboardStyles();

  const fetchDashboards = () => {};
  const { rtl, language } = useAppContext();
  const languageFilter: { languageName: string } = React.useMemo(
    () => ({ languageName: language }),
    [rtl]
  );
  const { dashboards, isLoading, loadDashboards } = useDashboardStore();
  const user = useCurrentUser();

  const dashboardsList = React.useMemo(() => {
    return dashboards?.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }, [dashboards]);

  React.useEffect(() => {
    loadDashboards(languageFilter);
  }, [languageFilter]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className={classes.page}>
      <div className={classes.slidesArea}>
        {dashboardsList?.map((board) => {
          return (
            <MyDashboard
              dashboard={board as any}
              onDashboardUpdated={fetchDashboards}
              key={board._id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MyDashboards;
